import flatten from 'lodash/flatten'
import {
  ExtendedDomainConfiguration,
  LocationFilterElement,
} from '../../domain-config/domain-config'

export function allFilters(config: ExtendedDomainConfiguration): LocationFilterElement[] {
  return [
    ...config.searchFilters.location,
    ...flatten(Object.values(config.searchFilters.additionalFilters)),
  ]
}
